<script lang="ts">
  import type { Page } from "$lib/gpu-glossary";
  import { themeStore } from "$lib/gpu-glossary";
  import NavItem from "./NavItem.svelte";

  export let contents: Page[];
</script>

<div class="py-6">
  <div class="flex flex-col gap-y-2" style:color={$themeStore.primary[80]}>
    {#each contents as section}
      <NavItem {section} showArrow={true} />
    {/each}
  </div>
</div>
